import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../layout/TitlePages";
import Modal from "../../layout/Modal/Modal";
import { dataDatosAbiertos } from "../../data/dataTransparencia";
import Breadcrumbs from "../../layout/Breadcrumbs";

const AccordionItem = ({ item, isOpen, onClick }) => (
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button
        className={`accordion-button ${isOpen ? "" : "collapsed"}`}
        type="button"
        onClick={onClick}
      >
        {item.titleItem}
      </button>
    </h2>
    <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
      <div className="accordion-body">
        {item.children.map((buttonModal) => (
          <ModalButton key={buttonModal.id} buttonModal={buttonModal} />
        ))}
      </div>
    </div>
  </div>
);

const ModalButton = ({ buttonModal }) => (
  <div>
    <button
      className="btn btn-ite w-100"
      data-bs-toggle="modal"
      data-bs-target={`#${buttonModal.idModal}`}
    >
      {buttonModal.titleModal}
    </button>
    <Modal
      idModal={buttonModal.idModal}
      titleModal={buttonModal.titleModal}
      sizeModal="modal-lg"
      contentModal={<ModalContent buttonModal={buttonModal} />}
    />
  </div>
);

const ModalContent = ({ buttonModal }) => (
  <div>
    <h5 className="mb-0">Tema: </h5>
    {buttonModal.titleTheme}
    <h5 className="mt-3 mb-0">Palabras clave: </h5>
    {buttonModal.keyWords}
    <h5 className="mt-3 mb-0">Descripción: </h5>
    {buttonModal.description}
    <h5 className="mt-3 mb-0">Área responsable: </h5>
    {buttonModal.area}
    <h5 className="mt-3 mb-0">Última actualización:</h5>
    {buttonModal.dateUpdate}
    <h5 className="mt-3 mb-0">Responsable de los datos:</h5>
    {buttonModal.contactName}
    <h5 className="mt-3 mb-0">Correo electrónico: </h5>
    {buttonModal.contactEmail}
    <h5 className="mt-3 mb-0">Datos y recursos: </h5>
    {buttonModal.subChildren.map((content) => (
      <DocumentLink key={content.id} content={content} />
    ))}
  </div>
);

const DocumentLink = ({ content }) => {
  const icons = {
    pdf: faFilePdf,
    word: faFileWord,
    excel: faFileExcel,
  };

  const btnClasses = {
    pdf: "btn btn-danger",
    word: "btn btn-primary",
    excel: "btn btn-success",
  };

  return (
    <div className="mt-1 mb-1">
      <a
        href={content.resoursePath}
        target="_blank"
        rel="noreferrer"
        className={btnClasses[content.typeDocument]}
      >
        <FontAwesomeIcon icon={icons[content.typeDocument]} />
      </a>{" "}
      {content.resourseTitle}
    </div>
  );
};

export const DatosAbiertos = () => {
  const [openItem, setOpenItem] = useState(null);

  const handleAccordionClick = (id) => {
    setOpenItem((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    document.title = `Datos Abiertos`;
  }, []);

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs path={[{ label: "Datos Abiertos" }]} />
        <TitlePages title="Datos Abiertos" subTitle="" />
        <div
          className="accordion accordion-flush w-50 mx-auto margin-bottom-1"
          id="metasMSPEN"
        >
          {dataDatosAbiertos.map((item) => (
            <AccordionItem
              key={item.id}
              item={item}
              isOpen={openItem === item.id}
              onClick={() => handleAccordionClick(item.id)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

// AccordionItem
AccordionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    titleItem: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

// ModalButton
ModalButton.propTypes = {
  buttonModal: PropTypes.shape({
    idModal: PropTypes.string.isRequired,
    titleModal: PropTypes.string.isRequired,
    titleTheme: PropTypes.string,
    keyWords: PropTypes.string,
    description: PropTypes.string,
    area: PropTypes.string,
    dateUpdate: PropTypes.string,
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    subChildren: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default DatosAbiertos;
